<template src="./index.html"></template>

<script>
import data from "./data.js";
import config from "../../../../../configHttp.js";
import { findPage,transportDel } from '@/api/transport';
export default {
  data: function () {
    return {
      options: data.options,
      value: "0",
      searchdata: data.searchdata,
      searchlist: data.searchlist,
      outlist: [],
      headData: data.headData,
      pagination: data.pagination,
      tableData: data.tableData,
      shaidiag: false,
      searchdiag: false,
      // 日期控件初始化时间
      dateValue: this.$getdefultMonth(),
      // 导出传参类型
      outputData: data.outputData,
      // 全部导出
      exportType: "1",
      tablekey: 0,
      overlength: 0,
        selectList:[],
    };
  },
  methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.fetchResultShow();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.fetchResultShow();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchResultShow();
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchResultShow();
    },
      selectionchange(e){
          this.selectList = e
      },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },

    // 查询进行发票合计结果(分页)
    fetchResultShow() {
      let params = JSON.parse(JSON.stringify(this.searchdata))
      let search = {
      	shenbq: this.dateValue,
      };

      if (this.searchdata.hasOwnProperty("bookkeepingDate")) {
          params.bookkeepingDateStart = params.bookkeepingDate[0];
          params.bookkeepingDateEnd = params.bookkeepingDate[1];
      }
        delete params['bookkeepingDate'];
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = "";
      params.order = "";
      params.search = search;
        findPage(params).then(res => {
      	this.pagination.total = res.data.data.total
      	this.tableData = res.data.data.records
      })
    },

    // 导出进项发票合计结果
    outPutIInvResult() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      if (selectVal.length == 0) {
        this.$message.info("请选中数据再进行更新取数操作");
        return;
      }
      let fapdms = new Array(selectVal.length);
      selectVal.forEach((v, k) => {
        fapdms[k] = v.fapdm;
      });
      let params = {
        downUrl: config.baseURL + "",
        typeObj: {
          toForm: false,
          fileName: "发票结果" + this.$timestampToStr(new Date(), "yyyyMMdd"),
          fileType: "xlsx",
        },
        params: {
          exportType: this.exportType,
          shenbq: this.dateValue,
          fapdms,
        },
      };
    },
      convertTaxRate(val) {
          if (val != null && val != ''){
              return this.multiply(val,100) + "%";
          }
          return "";
      },

      delClick(row){
          transportDel({id:row.taxval.id}).then(res =>{
              if (res.data.code == 1) {
                  this.$message.success("删除成功！");
              } else {
                  this.$message.error(res.data.msg);
              }
              this.fetchResultShow();
          })
      },
      batchDel(){
          if (this.selectList.length == 0) {
              this.$message.error("请选择要删除的数据！");
          }
          let ids = this.selectList.map(item => item.id).join(",");
          transportDel({id:ids}).then(res =>{
              if (res.data.code == 1) {
                  this.$message.success("删除成功！");
              } else {
                  this.$message.error(res.data.msg);
              }
              this.fetchResultShow();
          })
      },
      //乘法
      multiply(arg1,arg2){
          if (arg1 == undefined || arg1 == "NaN") {
              arg1 = 0
          }
          if (arg2 == undefined || arg2 == "NaN") {
              arg2 = 0
          }
          var m=0,s1=arg1.toString().replaceAll(",",""),s2=arg2.toString().replaceAll(",","");
          try{m+=s1.split(".")[1].length}catch(e){}
          try{m+=s2.split(".")[1].length}catch(e){}
          return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
      } ,
  },
  components: {},
  created() {
    this.fetchResultShow();
  },
  mounted() {},
  computed: {
    timeDefault() {
      let date = new Date();
      let newDate = date.getFullYear() + "年" + (date.getMonth() + 1) + "期";
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
